// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"breadcrumbs_breadcrumb__2hrUD","breadcrumb-item":"breadcrumbs_breadcrumb-item__RPcdt","active":"breadcrumbs_active__HQudH"};